<!--begin::Aside-->
<div id="kt_aside" class="aside aside-dark aside-hoverable" data-kt-drawer="true" data-kt-drawer-name="aside"
    data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
    data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
    data-kt-drawer-toggle="#kt_aside_mobile_toggle">
    <!--begin::Brand-->
    <div class="flex-column-auto text-center mt-5" id="kt_aside_logo">
        <!--begin::Logo-->
        <a [routerLink]="['/']" >
            <img alt="Logo" src="/assets/image/neu-logo.png" class="h-100px logo" />
        </a>
    </div>
    <!--begin::Aside menu-->
    <div class="aside-menu flex-column-fluid">
        <!--begin::Aside Menu-->
        <div class="hover-scroll-overlay-y my-5 my-lg-5" id="kt_aside_menu_wrapper" data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto"
            data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside_menu"
            data-kt-scroll-offset="0">
            <!--begin::Menu-->
            <div class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                id="#kt_aside_menu" data-kt-menu="true" data-kt-menu-expand="false">
                <div class="menu-item">
                    <a class="menu-link" [routerLink]="['.']" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <span class="menu-bullet">
                            <i class="fas fa-paste text-white"></i>
                        </span>
                        <span class="menu-title">Anasayfa</span>
                    </a>
                </div>
                <div class="menu-item">
                    <a class="menu-link" [routerLink]="['profil']" routerLinkActive="active">
                        <span class="menu-bullet">
                            <i class="fas fa-user text-white"></i>
                        </span>
                        <span class="menu-title">Profil Bilgilerim</span>
                    </a>
                </div>
                <div *ngIf="yetkiService.yetkiVar([]) && bilgiTamamlamaDurum" data-kt-menu-trigger="click"
                    class="menu-item menu-accordion">
                    <span class="menu-link">
                        <span class="menu-icon">
                            <i class="fas fa-chalkboard-teacher text-white
                            "></i>
                            <!--end::Svg Icon-->
                        </span>
                        <span class="menu-title">Talep İşlemleri</span>
                        <span class="menu-arrow"></span>
                    </span>
                    <div class="menu-sub menu-sub-accordion menu-active-bg">
                        <div class="menu-item">
                            <a class="menu-link" *ngIf=" talepSayMenu< 3 && talepSayMenu!=-1"
                                (click)="talepSayisiKontrol()" routerLinkActive="active">
                                <span class="menu-bullet">
                                    <i class="fas fa-plus"></i>
                                </span>
                                <span class="menu-title">Yeni Talep Oluştur</span>
                            </a>
                        </div>
                        <div class="menu-item">
                            <a class="menu-link" [routerLink]="['talep-list']" routerLinkActive="active">
                                <span class="menu-bullet">
                                    <i class="fas fa-list"></i>
                                </span>
                                <span class="menu-title">Talep Listesi</span>
                            </a>
                        </div>

                    </div>
                </div>

            </div>
            <!--end::Menu-->
        </div>
        <!--end::Aside Menu-->
    </div>
    <!--end::Aside menu-->
    <!--begin::Footer-->
    <div class="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
        <a href="https://www.erbakan.edu.tr/" class="btn btn-custom btn-primary w-100"
            data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss-="click"
            title="200+ in-house components and 3rd-party plugins" target="_blank">
            <span class="btn-label"> <i class="fas fa-university"></i>NEÜ</span>
            <!--begin::Svg Icon | path: icons/duotune/general/gen005.svg-->

            <!--end::Svg Icon-->
        </a>
    </div>
    <!--end::Footer-->
</div>
<!--end::Aside-->